import { booleanAttribute, Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'navigation-button',
  imports: [RouterLink, RouterLinkActive, NgIcon],
  template: `
    <div class="wrapper" [class.iconOnly]="showIconOnly()" [class.disabled]="disabled()">
      <a
        [routerLink]="href()"
        routerLinkActive="active-link"
        [class.disabled]="disabled()"
        [class.iconOnly]="showIconOnly()"
      >
        <ng-icon [name]="icon()!" size="18px" strokeWidth="1.5" />
        @if (!showIconOnly()) {
          <span class="label">{{ label() }}</span>
          @if (badge(); as badgeText) {
            <span class="badge">{{ badgeText }}</span>
          }
        }
      </a>
    </div>
  `,
  styleUrl: './navigation-button.scss',
})
export class NavigationButton {
  readonly href = input.required<string>();
  readonly label = input.required<string>();
  readonly badge = input<string>();
  readonly icon = input.required<string>();
  readonly showIconOnly = input<boolean>(false);
  readonly disabled = input<boolean>(false, { transform: booleanAttribute });
}
